import React, { useState, useEffect } from "react";
import "./Reporting.css";
import { useNavigate } from "react-router-dom";
import { db, storage } from "../firebase";
import { collection, doc, query, where, getDocs, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const ReportDisplay = () => {
  const navigate = useNavigate();
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [actionPlan, setActionPlan] = useState([]);
  const [inputs, setInputs] = useState({});

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/");
    }
  }, []);

  const name = localStorage.getItem("empname");
  const empId = localStorage.getItem("empid");

  useEffect(() => {
    if (!month) return;

    const fetchActionPlan = async () => {
      if (!month || !year) return;
      if (empId == "37" || empId == "32") {
        window.emplist = ["1", "2", "3", "4", "5", "6", "37", "42", "47", "52", "57", "62", "63", "72", "73", "82"];
      }
      if (empId == "38" || empId == "33") {
        window.emplist = ["7", "8", "9", "10", "11", "12", "38", "43", "48", "53", "58", "64", "65", "74", "75", "83"];
      }
      if (empId == "39" || empId == "34") {
        window.emplist = ["13", "14", "15", "16", "17", "18", "39", "44", "49", "54", "59", "66", "67", "76", "77", "84"];
      }
      if (empId == "40" || empId == "35") {
        window.emplist = ["19", "20", "21", "22", "23", "24", "40", "45", "50", "55", "60", "68", "69", "78", "79", "85"];
      }
      if (empId == "41" || empId == "36") {
        window.emplist = ["25", "26", "27", "28", "29", "30", "41", "46", "51", "56", "61", "70", "71", "80", "81", "86"];
      }
      if (empId == "31") {
        window.emplist = [
          "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83", "84", "85", "86"];
      }

      try {
        console.log(window.emplist);

        const chunkSize = 30;
        const allDocs = [];

        for (let i = 0; i < window.emplist.length; i += chunkSize) {
          const chunk = window.emplist.slice(i, i + chunkSize);

          const q = query(
            collection(db, "actionplan"),
            where("empid", "in", chunk),
            where("month", "==", String(month + " " + year)),
            where("budgetapproved", "!=", 0)
          );

          const querySnapshot = await getDocs(q);

          querySnapshot.forEach((doc) => {
            allDocs.push(doc);
          });
        }

        if (allDocs.length === 0) {
          setActionPlan([]);
          return;
        }

        const actions = [];
        const inputValues = {};

        allDocs.forEach((doc) => {
          const data = doc.data();
          const id = doc.id;

          actions.push({
            id,
            code: data.programCode || "",
            text: data.program || "",
            type: data.notesheettype,
            kvk: data.kvk
          });

          inputValues[id] = {
            campus: data.campus || "On Campus",
            days: data.days || 0,
            prgvenue: data.prgvenue || "",
            scm: data.scm || 0,
            scf: data.scf || 0,
            stm: data.stm || 0,
            stf: data.stf || 0,
            othm: data.othm || 0,
            othf: data.othf || 0,
            total: data.total || 0,
            picurl: data.picurl || "",
            tsurl: data.tsurl || "",
            billremarks: data.billremarks || "", // Added billremarks
            billurl: data.billurl || "",
          };
        });

        setActionPlan(actions);
        setInputs(inputValues);

      } catch (error) {
        console.error("Error fetching action plans:", error);
      }
    };

    fetchActionPlan();
  }, [month, year]);

  const handleChange = (id, field, value) => {
    let newValue = ["scm", "scf", "stm", "stf", "othm", "othf"].includes(field)
      ? parseInt(value) || 0
      : value;

    const updatedInputs = {
      ...inputs,
      [id]: {
        ...inputs[id],
        [field]: newValue,
      },
    };

    // Calculate total for numerical fields
    if (["scm", "scf", "stm", "stf", "othm", "othf"].includes(field)) {
      const { scm, scf, stm, stf, othm, othf } = updatedInputs[id];
      updatedInputs[id].total = (scm || 0) + (scf || 0) + (stm || 0) + (stf || 0) + (othm || 0) + (othf || 0);
    }

    setInputs(updatedInputs);
  };

  const handleFileUpload = async (id, file, type) => {
    if (!file) return;

    const fileRef = ref(storage, `uploads/${id}/${type}_${file.name}`);
    await uploadBytes(fileRef, file);
    const fileURL = await getDownloadURL(fileRef);

    setInputs((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [type]: fileURL,
      },
    }));

    return fileURL;
  };

  const handleSave = async (id) => {
    try {
      const dataToSave = {
        ...inputs[id],
        scm: Number(inputs[id].scm) || 0,
        scf: Number(inputs[id].scf) || 0,
        stm: Number(inputs[id].stm) || 0,
        stf: Number(inputs[id].stf) || 0,
        othm: Number(inputs[id].othm) || 0,
        othf: Number(inputs[id].othf) || 0,
        total: Number(inputs[id].total) || 0,
        days: Number(inputs[id].days) || 0,
        billremarks: inputs[id].billremarks || "", // Added billremarks to save
      };

      const actionRef = doc(db, "actionplan", id);
      await updateDoc(actionRef, dataToSave);
      alert("Saved successfully!");
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleBack = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  return (
    <div className="container">
      <h1 className="welcome">View Reports</h1>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label className="label">Select Month and Year:</label>
          <select
            className="dropdown"
            id="dd1"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          >
            <option value="">Month</option>
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        <select
          className="dropdown"
          id="dd2"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          style={{ width: "150px", height: "40px", marginTop: "33px" }}
        >
          <option value="">Year</option>
          {["2025", "2026", "2027", "2028"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </div>

      {actionPlan.length > 0 && (
        <div className="action-section">
          <table className="action-table">
            <thead>
              <tr>
                <th ><p style={{ fontSize: '12px'}}>KVK & Program Code</p></th>
                <th ><p style={{ fontSize: '12px'}}>Program Name</p></th>
                <th ><p style={{ fontSize: '12px'}}>Days</p></th>
                <th style={{width: '60px', fontSize: '12px'}}>Campus</th>
                <th ><p style={{ fontSize: '12px'}}>Venue</p></th>
                <th ><p style={{ fontSize: '12px'}}>SC(M)</p></th>
                <th ><p style={{ fontSize: '12px'}}>SC(F)</p></th>
                <th ><p style={{ fontSize: '12px'}}>ST(M)</p></th>
                <th ><p style={{ fontSize: '12px'}}>ST(F)</p></th>
                <th ><p style={{ fontSize: '12px'}}>OTH(M)</p></th>
                <th ><p style={{ fontSize: '12px'}}>OTH(F)</p></th>
                <th ><p style={{ fontSize: '12px'}}>Total</p></th>
                <th ><p style={{ fontSize: '12px'}}>Action Photo</p></th>
                <th ><p style={{ fontSize: '12px'}}>Trg-Distribution Sheet Action Report</p></th>
                <th ><p style={{ fontSize: '12px'}}>Bill Voucher</p></th>
                <th ><p style={{ fontSize: '12px'}}>Remarks on Bill Voucher</p></th>
              </tr>
            </thead>
            <tbody>
              {actionPlan.map((action) => (
                <tr key={action.id}>
                  <td>{action.kvk} <br /> {action.code}</td>
                  <td>{action.text}</td>
                  <td>
                    <input
                      disabled
                      type="number"
                      style={{ width: "40px" }}
                      value={inputs[action.id]?.days || ""}
                      onChange={(e) => handleChange(action.id, "days", e.target.value)}
                    />
                  </td>
                  <td style={{ width: '60px' }}>
                    <select
                      disabled
                      value={inputs[action.id]?.campus || "On Campus"}
                      onChange={(e) => handleChange(action.id, "campus", e.target.value)}
                      style={{ width: '60px' }}
                    >
                      <option value="On Campus">On</option>
                      <option value="Off Campus">Off</option>
                    </select>
                  </td>
                  <td>
                    <input
                      disabled
                      type="text"
                      style={{ width: "100px" }}
                      value={inputs[action.id]?.prgvenue || ""}
                      onChange={(e) => handleChange(action.id, "prgvenue", e.target.value)}
                    />
                  </td>
                  {["scm", "scf", "stm", "stf", "othm", "othf"].map((field) => (
                    <td key={field}>
                      <input
                        disabled
                        type="number"
                        defaultValue={0}
                        style={{ width: "40px" }}
                        value={inputs[action.id]?.[field] ?? ""}
                        onChange={(e) => handleChange(action.id, field, e.target.value)}
                      />
                    </td>
                  ))}
                  <td>{inputs[action.id]?.total || 0}</td>
                  <td>
                    {inputs[action.id]?.picurl && (
                      <a href={inputs[action.id].picurl} target="_blank" rel="noopener noreferrer">
                        Click to View
                      </a>
                    )}
                  </td>
                  <td>
                    {inputs[action.id]?.tsurl && (
                      <a href={inputs[action.id].tsurl} target="_blank" rel="noopener noreferrer">
                        Click to View
                      </a>
                    )}
                  </td>
                  <td>
                    {inputs[action.id]?.billurl && (
                      <a href={inputs[action.id].billurl} target="_blank" rel="noopener noreferrer">
                        Click to View
                      </a>
                    )}
                  </td>
                  <td>
                    <textarea
                      type="text"
                      rows="5"
                      style={{ width: "100px" }}
                      value={inputs[action.id]?.billremarks || ""}
                      onChange={(e) => handleChange(action.id, "billremarks", e.target.value)}
                      disabled={empId !== "31"}
                    />
                    {empId === "31" && (
                      <button onClick={() => handleSave(action.id)}>Save</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <img src="/assets/back.png" style={{ width: '100px'}} onClick={handleBack} alt="" />
    </div>
  );
};

export default ReportDisplay;